import { useState, useEffect } from 'react';
import './home.css';
import { Hour, Local, OutStationForm } from '../components/form';
import TariffComp from '../components/tariffComp';

import details from "../dataStore/details.json"

export default function Home(){
    
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    const [form, setForm] = useState("outstation")

// css for Typing location
    // let keyframe = `@keyframes typing{`
    let keyframe = ""
    let percentage = 0
    let type = ""
    for(let i =0;i<=details.typing.length+1; i++){
        if(i===0){
            keyframe+=`0%{content:"${details.typing[0]}"}`
            percentage+=(100/(details.typing.length+2))
        }else if(i===details.typing.length+1){            
            keyframe+=`100%{content:"${details.typing}"}`
        }else{
            type+=details.typing[i-1]
            keyframe+=`${percentage}%{content:"${type}"}`
            percentage+=100/details.typing.length
        }
    }
    // keyframe+="}"
    
    return(
        <>
        <style>
            {`@keyframes typing{
                ${keyframe}
            }`}
        </style>
        <section className="homeLandingSection" id='book'>
            <div className="wrapper">
                <div className="homeLanding">
                    <article>
                        <header>
                            <h1>{details.name}<span></span></h1>
                            <p>24/7 Taxi Service, Anywhere Anytime</p>                            
                        </header>
                        <div className='homeForm'>
                            <div className='tabs'>
                                <h3 className={form==='outstation'?"tabColor":""} onClick={()=>setForm("outstation")}>Outstation</h3>
                                <h3 className={form==='local'?"tabColor":""} onClick={()=>setForm("local")}>Local</h3>
                                <h3 className={form==='hour'?"tabColor":""} onClick={()=>setForm("hour")}>Hours</h3>
                            </div>
                            {form==="outstation"?<OutStationForm/>:form==="local"?<Local/>:form==="hour"?<Hour/>:null}
                        </div>
                    </article>
                    <aside>
                        <a href={`tel:+91${details.primary_phone}`} className='infoContainer'>
                            <figure>
                                <img src='./images/telephone.png' alt=''/>
                            </figure>
                            <h3>Call</h3>
                            <h4>{details.primary_phone}</h4>
                        </a>
                        {/* <a href='https://api.whatsapp.com/send/?phone=%2B919150117650&text&type=phone_number&app_absent=0' className='infoContainer'> */}
                        <a href={`https://wa.me/+91${details.secondary_phone}`} className='infoContainer'>
                            <figure>
                                <img src='./images/whatsapp.png' alt=''/>
                            </figure>
                            <h3>Chat</h3>
                            <h4>{details.secondary_phone}</h4>
                        </a>
                        <a href={`mailto:${details.mail}`} className='infoContainer'>
                            <figure>
                                <img src='./images/mail2.png' alt=''/>
                            </figure>
                            <h3>Mail</h3>
                            <h4>{details.mail}</h4>
                        </a>
                    </aside>
                </div>
            </div>
        </section>

        <section className='serviceContainer wrapper'>
            <h2>Our <span>Services</span></h2>
            <p>24/7 Taxi Service</p>
            <div className='services'>
                <div className='service'>
                    <figure>
                        <img src='./images/airport.svg' alt=''/>
                    </figure>
                    <h3>Airport Taxi</h3>
                    <p>{details.name} offers 24/7 cheap and best airport taxi service across Tamilnadu.</p>
                </div>
                <div className='service'>
                    <figure>
                        <img src='./images/taxi.svg' alt=''/>
                    </figure>
                    <h3>24/7 call Taxi</h3>
                    <p>{details.name} offers 24/7 one way, Round trip service at reasonable price.</p>
                </div>
                <div className='service'>
                    <figure>
                        <img src='./images/tour.svg' alt=''/>
                    </figure>
                    <h3>Outstation Taxi</h3>
                    <p>{details.name} Provide Corporate Transport service with Profeesional manner</p>
                </div>
                <div className='service'>
                    <figure>
                        <img src='./images/corporate.svg' alt=''/>
                    </figure>
                    <h3>Station Taxi</h3>
                    <p>{details.name} Chennai offers 24/7 cheap and best outstation taxi service across Tamil Nadu.</p>
                </div>
            </div>
            <a href="#book" className='Btn serviceBtn'>Book Now</a>
        </section>
        
        <section className='aboutContainer wrapper'>
            <figure>
                <img src='./images/homeAbout.png' alt="Zion"/>
            </figure>
            <article>
                <h2>Experience the liberty to explore any <br/><span>Destination you Desire</span></h2>
                <p>
                    {details.name} provides round-the-clock taxi services throughout Tamil Nadu,
                    including Airport Taxi, One Way Taxi, Outstation Taxi, Station Taxi,
                    and Local Taxi Service. As a premier taxi service provider in the region,
                    our mission is to offer fast and affordable transportation for all.
                </p>
                <ul>
                    <li>Over 100 vehicles in Tamil Nadu</li>
                    <li>We take care to provide a dense network of vehicles</li>
                    <li>24/7 Service</li>
                </ul>
                <a href='#book' className='Btn aboutBtn'>Book Now</a>
            </article>

        </section>

        <section className='aboutContainer about2 wrapper'>
            <article>
                <h2>Save time by selecting<br/><span> the perfect Taxi</span></h2>
                <p>3 simple steps to book your taxi</p>
                <a href='#book' className='Btn aboutBtn'>Book Now</a>
            </article>
            <figure>
                <img src='./images/homeBook.png' alt="Zion"/>
            </figure>
        </section>
        
        <section className='wrapper'>
            <TariffComp/>
        </section>

        <section className='wrapper package'>
            <h2>Our <span>Tour Package</span></h2>
            <figure>
                <img src='./images/pack1.png' alt='Velangani'/>
                <img src='./images/pack2.png' alt='Pondy'/>
                <img src='./images/pack3.png' alt='Tirupati'/>
                <img src='./images/pack4.png' alt='Chennai'/>
            </figure>
            <a href='#book' className='Btn packageBtn'>Book Now</a>
        </section>      
        </>
    )
}